import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, IconButton, Menu, MenuItem, Typography } from '@mui/material'
import FlagEmoji from './common/FlagEmoji'

const languages = [
  { code: 'en', flag: '🇺🇸', label: 'EN' },
  { code: 'fr', flag: '🇫🇷', label: 'FR' },
  { code: 'ar', flag: '🇲🇦', label: 'AR' },
  { code: 'de', flag: '🇩🇪', label: 'DE' },
  { code: 'it', flag: '🇮🇹', label: 'IT' },
]

const LanguageSelector = ({ variant }) => {
  const { i18n } = useTranslation()
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)
  const isDark = variant === 'dark'

  const currentLang = languages.find(l => l.code === i18n.language) || languages[0]

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleLanguageChange = (code) => {
    i18n.changeLanguage(code)
    handleClose()
  }

  return (
    <>
      <IconButton
        onClick={handleClick}
        sx={{
          fontSize: '24px',
          width: 40,
          height: 40,
          borderRadius: '10px',
          border: isDark ? '1px solid rgba(255,255,255,0.08)' : '1px solid rgba(0,0,0,0.1)',
          backgroundColor: isDark ? 'rgba(255,255,255,0.04)' : 'rgba(255,255,255,0.9)',
          '&:hover': {
            backgroundColor: isDark ? 'rgba(255,255,255,0.08)' : 'rgba(255,255,255,1)',
          }
        }}
      >
        <FlagEmoji emoji={currentLang.flag} size={22} />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            borderRadius: '10px',
            mt: 1,
            minWidth: 100,
            ...(isDark ? {
              backgroundColor: '#1a1a1a',
              border: '1px solid rgba(255,255,255,0.06)',
              boxShadow: '0 8px 40px rgba(0,0,0,0.7)',
            } : {
              boxShadow: '0 4px 20px rgba(0,0,0,0.12)',
            }),
          }
        }}
      >
        {languages.map((lang) => (
          <MenuItem
            key={lang.code}
            selected={lang.code === i18n.language}
            onClick={() => handleLanguageChange(lang.code)}
            sx={{
              py: 1,
              px: 2,
              gap: 1.5,
              borderRadius: '6px',
              mx: 0.5,
              ...(isDark ? {
                color: 'rgba(255,255,255,0.7)',
                '&:hover': {
                  backgroundColor: 'rgba(255,255,255,0.06)',
                },
                '&.Mui-selected': {
                  backgroundColor: 'rgba(255,255,255,0.08)',
                  color: '#fff',
                },
              } : {
                '&.Mui-selected': {
                  backgroundColor: 'rgba(0,0,0,0.06)',
                },
              }),
            }}
          >
            <FlagEmoji emoji={lang.flag} size={20} />
            <Typography
              variant="body2"
              fontWeight={lang.code === i18n.language ? 600 : 400}
              sx={isDark ? { color: 'inherit' } : {}}
            >
              {lang.label}
            </Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}

export default LanguageSelector
